import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import _styles from './styles.module.css';

const CardBody = ({ children, fluid, padded, styles, parentStyles }: any) => (
  <div
    className={cnames(
      styles.container,
      parentStyles.cardBody,
      {
        [styles.fluid]: fluid,
        [styles.padded]: padded,
      },
    )}
  >
    { children }
  </div>
);

(CardBody as any).propTypes = {
  children: PropTypes.node.isRequired,
  fluid: PropTypes.bool,
  padded: PropTypes.bool,
  styles: PropTypes.shape({}),
  parentStyles: PropTypes.shape({}),
};

(CardBody as any).defaultProps = {
  fluid: false,
  padded: true,
  styles: _styles,
  parentStyles: null,
};

(CardBody as any).displayName = 'CardBody';

export default CardBody;
